module.exports = __webpack_public_path__ + "img/gingery-chinese-stir-fry.58736675.jpg";